import {Icon, Input, InputNumber, message, Select, Spin, Tooltip} from 'antd';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {
    receivedPreviewStatus,
    setDropDistancePointLength,
    setDropDistancePointOnly,
    setFocusPoints,
    setPreviewStatusToConfirmed,
    setScanName,
    takePreviewBlood,
    updatePreviewStatus
} from '../../../redux_actions/preview_status.action';
import {RegionSelectionConstants} from "../../../redux_constants/region_selection.constant";
import '../../../asset/style/workflow/slide.css';
import {EventNumberMap, objectiveType, scanSpeed, specimenType} from '../../../utils/const';
import {setDeviceIdle} from '../../../redux_actions/device_status.action';
import {ScanApiConstant} from '../../../redux_constants/scan.constant';
import {updateCountSlotWise} from '../../../redux_actions/bloodConfig.action'
import querystring from "query-string";
import {getKeyByValue, notNull} from "../../../utils/utils";
import {get, post} from "../../../helper/request";

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    // 'Blood': specimenType.BLOOD,
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

const initialState = {
    tissueType: null,
    scanSpeed: null,
    objective: null,
    takePreview: false,
    isFetching: false,
    barcodeAngle: -90,
    selected: false,
    blood10XRunning: false,
    slide_info: {},
    WBCCount: parseInt(Object.values(EventNumberMap)[0]),
    customEventBox: false,
}

const {Option} = Select;

class BloodSlideView extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount = () => {
        this.setState({
            tissueType: getKeyByValue(SPECIMEN, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.specimenType : this.props.preview.specimenType),
            scanSpeed: getKeyByValue(SCAN_SPEED, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.scanSpeed : this.props.preview.speed),
            objective: getKeyByValue(OBJECTIVE, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.objectiveType : this.props.preview.objectiveType),
        });

        let slot_status = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id]
        let slide_name = ((slot_status||{}).previewResponse||{}).slideName;
        if (slide_name) {
            this.props.dispatch(setScanName(this.props.slot_id, slide_name));
        }
        if (notNull(slot_status)) {
            if (slot_status?.previewStage === RegionSelectionConstants.CONFIRMED) {
                this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, (slot_status || {}).previewResponse, this.props.slot_id));
                this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
            } else {
                this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, (slot_status || {}).previewResponse, this.props.slot_id));
            }
        }

        if (((this.props.bloodConfig || {}).countWBCSlotWise || {})[this.props.slot_id]) {
            this.setState({
                WBCCount: ((this.props.bloodConfig || {}).countWBCSlotWise || {})[this.props.slot_id]
            })
        } else {
            this.props.dispatch(updateCountSlotWise([this.props.slot_id, this.state.WBCCount]));
        }

        let currBloodStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus[this.props.slot_id];
        if(currBloodStatus?.previewStage===RegionSelectionConstants.COARSE_STARTED){
            this.setState({
                blood10XRunning: true,
            })
        }
    }

    componentDidUpdate = (prevProps) => {
        let prevPreviewStatus = (((prevProps.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus;
        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus;

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (key === this.props.slot_id) {
                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.FETCHED_IMAGE) ||
                    (prevPreviewStatus[key] !== undefined && prevPreviewStatus[key].previewStage.toLowerCase() !== RegionSelectionConstants.FETCHED_IMAGE &&
                        value.previewStage.toLowerCase() === RegionSelectionConstants.FETCHED_IMAGE)) {
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, value.previewResponse, key));
                }

                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.CONFIRMED) ||
                    (prevPreviewStatus[key] !== undefined && ((prevPreviewStatus[key].previewStage.toLowerCase() !== RegionSelectionConstants.CONFIRMED &&
                            value.previewStage.toLowerCase() === RegionSelectionConstants.CONFIRMED) ||
                        (prevPreviewStatus[key].previewConfirmedCount !== value.previewConfirmedCount && value.previewStage === RegionSelectionConstants.CONFIRMED)))) {
                    this.confirmPreviewStatus(value.previewResponse);
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, value.previewResponse, key));
                    this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
                }

                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.COARSE_DONE) ||
                    (prevPreviewStatus[key] !== undefined && ((prevPreviewStatus[key].previewStage !== RegionSelectionConstants.COARSE_DONE &&
                        value.previewStage === RegionSelectionConstants.COARSE_DONE)))) {
                    this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.COARSE_DONE));
                }
            }
        }
        let prevBloodStatus = prevPreviewStatus[this.props.slot_id]
        let currBloodStatus = currPreviewStatus[this.props.slot_id]

        if ((currBloodStatus || {}).previewStage !== undefined && (prevBloodStatus || {}).previewStage !== RegionSelectionConstants.COARSE_STARTED
            && (currBloodStatus || {}).previewStage === RegionSelectionConstants.COARSE_DONE && this.state.slide_info === {}) {
            this.getSlideInfo();
        }

        if (((currBloodStatus || {}).previewResponse || {}).slideName !== ((prevBloodStatus || {}).previewResponse || {}).slideName) {
            let slideName = ((currBloodStatus || {}).previewResponse || {}).slideName;
            this.setSlideNameFirstTime(slideName);
        }

        if (this.state.slide_info === {} && (currBloodStatus || {}).previewStage === RegionSelectionConstants.COARSE_DONE) {
            this.getSlideInfo();
        }


        if ((prevBloodStatus || {}).previewStage !== RegionSelectionConstants.COARSE_STARTED && (currBloodStatus || {}).previewStage === RegionSelectionConstants.COARSE_STARTED) {
            this.setState({
                blood10XRunning: true,
            })
        }

        if ((prevBloodStatus || {}).previewStage === RegionSelectionConstants.COARSE_STARTED && (currBloodStatus || {}).previewStage === RegionSelectionConstants.COARSE_DONE) {
            this.setState({
                blood10XRunning: false,
            })
        }
    }

    componentWillUnmount = () => {
        this.setState({
            initialState,
        });
    }

    thresholdCanvasRef = thresholdCanvas => this.thresholdCanvas = thresholdCanvas;

    getSlideInfo = () => {
        let morphle_id = ((((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health) || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id] || {}).previewResponse || {}).morphleId
        console.log("morphle_id", morphle_id, this.props.slot_id);
        if (morphle_id) {
            let url = `/api/get_slide_data/?morphle_id=${morphle_id}`
            get(url).then(data => {
                this.setState({
                    slide_info: data,
                })
            })
        }
    }
    
    confirmPreviewStatus = (response) => {
        let region = this.props.preview.region !== undefined ? this.props.preview.region : {};
        let actualRegion = this.props.preview.actualRegion !== undefined ? this.props.preview.actualRegion : [];
        this.props.dispatch(setPreviewStatusToConfirmed(this.props.slot_id, region, actualRegion));
        this.props.dispatch(setDropDistancePointOnly(this.props.slot_id, response.dropDistancePoint));
        this.props.dispatch(setDropDistancePointLength(this.props.slot_id, response.dropDistancePoint));
        this.props.dispatch(setFocusPoints(this.props.slot_id, response.focusPoints));
        this.props.dispatch(setDeviceIdle(this.props.device_id));
        this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
        this.setState({
            isFetching: false,
        });
    }

    takePreview = () => {
        let safe = this.isSafeToClick();
        if (!safe) {
            message.info("Preview already going on.")
            return;
        }
        if (!(this.props.deviceStatus[this.props.device_id] || {}).uiBusy) {
            this.setState({
                isFetching: true,
            });
            this.props.dispatch(takePreviewBlood(this.props.device_id, this.props.slot_id));
        }
    }

    expandEditor = () => {
        this.props.expandedSlideView(this.props.slot_id);
    }

    rotateBarcode = () => {
        this.setState({
            barcodeAngle: this.state.barcodeAngle + 90,
        })
    }

    setSlideNameFirstTime = (name) => {
        let currBloodStatus = ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health) || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id]
        let slide_id = ((currBloodStatus || {}).previewResponse || {}).slideId;
        let val = {
            "slide_id": slide_id,
            "slot_id": this.props.slot_id,
            "slide_name": name,
        }
        let url = `/server/devices/${this.props.device_id}/update_blood_slide_name/`;
        post(url, querystring.stringify(val)).then()
        this.props.dispatch(setScanName(this.props.slot_id, name));
    }

    setSlideName = (e) => {
        let currBloodStatus = ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health) || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id]
        let slide_id = ((currBloodStatus || {}).previewResponse || {}).slideId;
        let val = {
            "slide_id": slide_id,
            "slot_id": this.props.slot_id,
            "slide_name": e.target.value,
        }
        let url = `/server/devices/${this.props.device_id}/update_blood_slide_name/`;
        post(url, querystring.stringify(val)).then()
        this.props.dispatch(setScanName(this.props.slot_id, e.target.value));
    }

    isSafeToClick = () => {
        let previewStatus = (((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health) || {}).scanner_response || {}).scanPreviewStatus || {})
        for (const [key, value] of Object.entries(previewStatus)) {
            if (value.previewStage === RegionSelectionConstants.COARSE_STARTED) {
                return false;
            }
        }
        return true;
    }


    close = () => {
        this.setState({
            keepCrashedNotification: false
        })
    };
    setWBCCount = (countStr) => {
        if (countStr === EventNumberMap.Custom.toString()) {
            this.setState({customEventBox: true})
            countStr = countStr.split('-')[1]
        }
        let count = parseInt(countStr);
        this.setState({
            WBCCount: count,
        })
        this.props.dispatch(updateCountSlotWise([this.props.slot_id, count]));
    }

    onSearch = (value) => {
        console.log('search:', value);
    };

    render() {
        let currBloodStatus = ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health) || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id]

        let isFetchingAllPreviews = false;

        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus;

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (value.previewOngoing) {
                isFetchingAllPreviews = true;
                break;
            }
        }

        let showNameField = (currBloodStatus || {}).previewStage === RegionSelectionConstants.COARSE_DONE || (currBloodStatus || {}).previewStage === RegionSelectionConstants.CONFIRMED;

        let eventDropdownOption = Object.keys(EventNumberMap).map((key) => {
            return <Option value={EventNumberMap[key.toString()]}>{key}</Option>
        })

        let WBCCountDropdown = <Select
            showSearch
            placeholder="WBC Count"
            defaultValue={this.state.WBCCount.toString()}
            value={this.state.WBCCount.toString()}
            optionFilterProp="children"
            onChange={this.setWBCCount}
            onSearch={this.onSearch}
            disabled={!showNameField}
            filterOption={(input, option) => {
                if (option.props.children) {
                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }
            }}
            style={{width: '90px'}}
        >
            {eventDropdownOption}
        </Select>

        let quickSettings = <div className='quick-settings-button-group'>
            {showNameField ?
                <Input size="small" placeholder="Slide Name" style={{marginTop: '5px'}}
                       onChange={this.setSlideName} value={this.props.preview.slideName}/> : null}
            <p></p>

            <span><b>Event </b>
                {this.state.customEventBox ? <InputNumber min={1} max={5000} value={this.state.WBCCount}
                                                          onChange={this.setWBCCount}/> : WBCCountDropdown}
                                </span>
        </div>

        const date = new Date();
        
        let preview_image = (((((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health) || {}).scanner_response || {}).scanPreviewStatus)[this.props.slot_id] || {}).previewResponse || {}).previewPath;
        if (preview_image !== undefined) {
            preview_image = preview_image.replace("/media/scandrive/scans", "/scan-hdd");
        }
        let slide = null;

        if ((currBloodStatus || {}).previewStage === RegionSelectionConstants.COARSE_DONE || (currBloodStatus || {}).previewStage === RegionSelectionConstants.CONFIRMED) {
            slide = <div className='filled-preview-container'
                         style={this.props.preview.status === RegionSelectionConstants.CONFIRMED ? {boxShadow: '0px 4px 8px 2px green'} : {boxShadow: '0px 4px 8px 2px rgba(0,0,0,0.5)'}}>
                <Tooltip placement="rightTop"
                         title={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ?
                             "Click to modify scan settings" : ""}>
                    <div
                        onClick={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ?
                            this.expandEditor : (e) => {
                                e.stopPropagation();
                            }}
                        className={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ?
                            "filled-slide" : "filled-action-ongoing-slide"}>
                        <p>Change Scan Region</p>
                        <img className="slot-image" src={preview_image + `/overlayed_mask_for_path.jpg/?d=${date}`} alt={"Scan Mask"}/>
                    </div>
                </Tooltip>
                <Tooltip placement="rightTop" title={"Rotate Barcode"}>
                    <div className="barcode-filled" onClick={this.rotateBarcode}>
                        <img className="barcode-image" src={preview_image + '/barcode_crop.jpg'}
                            alt={"Barcode"}
                             style={{transform: 'rotate(' + this.state.barcodeAngle + 'deg)'}}/>

                        <div className="rotate"><Icon type="reload"/></div>
                    </div>
                </Tooltip>
                {/* <RedoOutlined  style={{backgroundColor: 'white', padding: '10px 20px 0px 20px'}} onClick={this.rotateBarcode}/> */}
                <div style={{display: 'flex', align: 'bottom', borderTop: '2px solid black'}}>
                    {quickSettings}
                </div>
            </div>
        } else {
            slide = <div
                className={(this.props.preview || {}).status === RegionSelectionConstants.CONFIRMED ? 'empty-confirmed-preview-container' : 'empty-unconfirmed-preview-container'}>

                <div
                    onClick={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ? this.takePreview : (e) => {
                        e.stopPropagation();
                    }}//&&(this.isSafeToClick() ||
                    className="centered empty-slide"
                    style={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ? {cursor: 'pointer'} : null}>
                    <p>Click to see the Auto-Detected Region</p>
                </div>
                <div className="barcode-empty">

                </div>
                <div style={{display: 'flex', align: 'bottom', borderTop: '2px solid black'}}>
                    {quickSettings}
                </div>
            </div>

        }

        return (
            <Spin spinning={this.state.blood10XRunning}>
                <div className='slide-container'>
                    {slide}
                    <canvas ref={this.thresholdCanvasRef} className="region-selection-canvas-new"
                            style={{display: 'none'}}/>
                </div>
            </Spin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        preview: state.previewStatusReducer[ownProps.slot_id],
        deviceStatus: state.deviceStatusReducer,
        bloodConfig: state.bloodConfigReducer,
    };
};

export default connect(mapStateToProps, null, null, {forwardRef: true})(BloodSlideView);
